<app-pi-indicador-flujo></app-pi-indicador-flujo>
<div class="invalidez-layout">

  <main class="invalidez-content" *ngIf="error">

    <!-- Error general (reintentos / servicio no disponible) -->
    <div class="generic-error-container general-error" *ngIf="error?.useGeneralErrorLayout">
      <div class="general-header">
        <ds-icon class="general-error-icon" name="ErrorFill" [size]="24" [fill]="true" ariaLabel="Error">
        </ds-icon>
        <h2 class="ds-text-h2-bold general-title">{{error.title}}</h2>
      </div>

      <div class="general-body">
        <p class="ds-text-body-l-regular general-subtitle" [innerHTML]="error.subtitle"></p>
      </div>

      <div class="inline-alert" *ngIf="error?.infoBoxHtml" [innerHTML]="error.infoBoxHtml"></div>

      <div class="general-actions">
        <p *ngIf="error?.textButton">
          <ds-button-v2 class="btn-generic-error" label="{{error.textButton}}" emphasis="primary" size="m"
            (click)="goToClick(error.eventClickButton)" />
        </p>
        <p *ngIf="error?.textButton2">
          <ds-button-v2 class="btn-generic-error pi-btn-2" label="{{error.textButton2}}" emphasis="secondary"
            size="m" (click)="goToClick(error.eventClickButton2)" />
        </p>
      </div>
    </div>

    <!-- Errores de validación (AU05 / AU06 / AU09 / AU10, etc.) -->
    <div class="generic-error-container validation-error" *ngIf="!error?.useGeneralErrorLayout">
      <div class="validation-header">
        <ds-icon *ngIf="error?.iconName" name="{{error.iconName}}" [size]="24" [fill]="true"
          ariaLabel="Información" class="validation-icon">
        </ds-icon>
        <h2 class="ds-text-h2-bold validation-title">{{error.title}}</h2>
      </div>

      <div class="validation-body">
        <p *ngIf="error?.subtitle" class="ds-text-body-l-regular validation-subtitle" [innerHTML]="error.subtitle"></p>
        <div class="info-extra" *ngIf="error?.infoBoxHtml" [innerHTML]="error.infoBoxHtml"></div>
        <div *ngIf="error?.tituloLista && error?.lista?.length" class="beneficiary-review">
          <p class="ds-text-body-l-bold beneficiary-review__title">{{ error.tituloLista }}</p>
          <p *ngIf="error.lista.length > 1 && error?.introLista" class="ds-text-body-l-regular beneficiary-review__intro">
            {{ error.introLista }}
          </p>
          <ul class="beneficiary-review__list">
            <li *ngFor="let item of error.lista" class="ds-text-body-l-regular" [innerHTML]="item"></li>
          </ul>
        </div>
        <div *ngIf="error?.lista?.length && error?.message" class="beneficiary-next">
          <h3 class="ds-text-h3-s-bold">¿Qué viene ahora?</h3>
          <p class="ds-text-body-l-regular">{{ error.message }}</p>
        </div>
      </div>

      <div class="validation-actions">
        <p *ngIf="error?.buttonTextPrimary">
          <ds-button-v2 class="btn-generic-error" label="{{error.buttonTextPrimary}}" emphasis="primary" size="m"
            (click)="goToPage(error.buttonElementoPrimary, error.buttonTextPrimary, error.buttonElementoTipoPrimary, error.buttonUrlPrimary)" />
        </p>
        <p *ngIf="error?.lista?.length && error?.textButton">
          <ds-button-v2 class="btn-generic-error" label="{{error.textButton}}" emphasis="primary" size="m"
            (click)="goToClick(error.eventClickButton)" />
        </p>
        <p *ngIf="error?.buttonTextSecondary">
          <ds-button-v2 class="btn-generic-error pi-btn-2" label="{{error.buttonTextSecondary}}" emphasis="secondary"
            size="m"
            (click)="goToPage(error.buttonElementoSecondary, error.buttonTextSecondary, error.buttonElementoTipoSecondary, error.buttonUrlSecondary)" />
        </p>
        <p *ngIf="error?.lista?.length && error?.textButton2">
          <ds-button-v2 class="btn-generic-error pi-btn-2" label="{{error.textButton2}}" emphasis="secondary"
            size="m" (click)="goToClick(error.eventClickButton2)" />
        </p>
      </div>
    </div>

  </main>

</div>
